import { UseToastOptions } from "@chakra-ui/react";

export const errorToastOptions: UseToastOptions = {
  status: "error",
  variant: "subtle",
  isClosable: true,
  duration: 5000,
  position: "bottom",
};
